<template>
    <li v-if="bonuses.enabled">
      <div>
        <div class="label">{{ i18n.t('bonuses:reward') }}</div>
        <div class="value">{{ (bonus && bonus.name) || 'No bonus selected' }}</div>
      </div>
      <a @click="changeBonus">{{ i18n.t('base:edit') }}</a>
      <bonus-selector v-if="bonuses.visible" :screen="'bonuses'" :fullScreen="true" />
    </li>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'

  import BonusSelector from '../components/BonusSelector'

  export default Vue.component('flow-confirmation-list', {
    components: {
      'bonus-selector': BonusSelector
    },
    props: ['screenParams'],
    computed: {
      ...mapState(['user', 'bonuses']),
      bonus () {
        const userBonus = this.user.selectedBonus
        return userBonus && this.bonuses.list.find(bonus => bonus.name === userBonus)
      }
    },
    methods: {
      changeBonus () {
        this.$store.dispatch('updateBonuses', {
          visible: true
        })
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/FlowListBonusEntry.vue